@if (graphLoaded) {
<div id="chart" [class]="applyBoxStyling ? 'chart' : ''">
	<div style="position: relative;">
		<apx-chart [title]="chartOptions.title" [series]="chartOptions.series" [chart]="chartOptions.chart"
			[grid]="chartOptions.grid" [plotOptions]="chartOptions.plotOptions" [dataLabels]="chartOptions.dataLabels"
			[responsive]="chartOptions.responsive" [xaxis]="chartOptions.xaxis" [fill]="chartOptions.fill"
			[colors]="chartOptions.colors" [legend]="chartOptions.legend"></apx-chart>
		@if (enableDevicesToggle) {
		<mat-form-field class="select">
			<mat-select (selectionChange)="deviceToggleChanged()" [(value)]="deviceToggleValue">
				<mat-option value="All">All Devices</mat-option>
				<mat-option value="Active">Active Devices</mat-option>
			</mat-select>
		</mat-form-field>
		}
		@if (pagination) {
		<button mat-button color="dark" [disabled]="currentPage == 1" class="left-pagination"
			(click)="onChangePage(currentPage - 1)">Prev</button>
		}
		@if (pagination) {
		<button mat-button color="dark" [disabled]="currentPage == total / 10" class="right-pagination"
			(click)="onChangePage(currentPage + 1); $event.preventDefault(); $event.stopPropagation()">Next</button>
		}
	</div>
</div>
}